export class User {
  id: string;
  name: string;
  email: string;
  mobile_no: string;

  constructor(args: any) {
    this.id = args.id;
    this.name = args.name;
    this.email = args.email;
    this.mobile_no = args.mobile_no;
  }
}
